import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { Partner } from './Partner.js';

/**
 * @entity SubDivision
 */
@Entity()
export class SubDivision extends Partner {
  static override _class = 'SubDivision';

  @Field(type => String)
  public parentID: Maybe<string>;

  @DataLoadedField(type => Partner, ({ parentID }) => parentID)
  public parent: Maybe<Partner>;

  @Field(type => String)
  public divisionURL: Maybe<string>;

  override get type() {
    return KooperationsPartner.SUB_DIVISON;
  }
}
